<template>
    <div v-if="visible">
        <el-dialog
         title="待上课程"
         class="lessonDialog"
         :visible.sync="dialogShow"
         width="20%"
         @close="closeDialog">
            <el-card
             style="padding: 0px"
             v-for="(item, index) in lessonList"
             :key="index">
                <img :src="item.lesson.pptCover" class="pptCover">
                <div>
                    <div class="flex-end">
                        <span class="lessonName">{{ item.lesson.name }}</span>
                        <span>{{ item.teacherName }}</span>
                    </div>
                    <div class="flex-end">
                        <div>
                            <span>{{ `${item.date}` }}</span>
                            <span>{{ `${item.startTime}-${item.endTime}` }}</span>
                        </div>
                        <span class="lesson-one">{{ item.onlineTeaching? "线上课" : "线下课" }}</span>
                    </div>
                    <div class="flex-end">
                        <el-alert
                        :title="countDown > 0? '距开始上课' : ''"
                        type="success"
                        center
                        :closable="false">
                            <span v-if="countDown > 0" style="font-size: 30px">{{ `${parseInt(countDown/60/60)} 时 ${parseInt(countDown/60 %60)} 分 ${countDown%60} 秒` }}</span>
                            <span v-else class="defaultText">已开始上课</span>
                        </el-alert>
                    </div>
                    <div class="flex">
                        <el-button type="primary" round :disabled="disabled" @click="inClassroomDialogVisible(item)" class="button">进入课堂</el-button>
                    </div>
                </div>
            </el-card>
            <CodeDialog :lessonId="currentLessonId" ref="codeDialog"></CodeDialog>
        </el-dialog>
    </div>
</template>
<script>
import communityApi from '@/request/api/community';
import tencentApi from '@/request/api/tencent';
import classApi from '@/request/api/class';
import CodeDialog from '@/components/dialog/codeDialog';
export default {
    components: { CodeDialog },
    computed: {
        visible() {
            if(this.$store.state.lessonDialogShow) this.getLessonLit()
            return this.$store.state.lessonDialogShow
        },
    },
    data() {
        return {
            dialogShow: false,
            lessonList: [],
            date: new Date(),
            currentDate: "",
            currentTime: "",
            hours: "",
            minutes: "",
            countDown: 0,
            disabled: false,
            currentLessonId: "",
        }
    },
    created() {
        this.currentDate = `${this.date.getFullYear()}-${String(this.date.getMonth() + 1).length > 1? this.date.getMonth() + 1 : '0' + String(this.date.getMonth() + 1)}-${String(this.date.getDate()).length > 1? this.date.getDate() : '0' + String(this.date.getDate())}`
        this.hours = this.date.getHours();
        this.minutes = this.date.getMinutes();
        console.log(this.currentDate, this.hours, this.minutes)
    },
    methods: {
        getLessonLit() {
            let params = {
                type: 'scratch'
            };
            communityApi.stuClassSchedule(params, res => {
                if(res.succeed) {
                    console.log(res)
                    for(let i = 0; i < res.data.length; i++) {
                        if(res.data[i].date == this.currentDate) {
                            console.log(res.data[i].date, this.currentDate)
                            console.log(res.data[i].endTime.split(":")[1], this.minutes)
                            if(res.data[i].endTime.split(":")[0] > this.hours) {
                                console.log(res.data[i])
                                this.lessonList= [res.data[i]]
                                this.currentLessonId = res.data[i].lessonId;
                                this.calculateTime(res.data[i].startTime)
                                return;
                            } else if(res.data[i].endTime.split(":")[0] == this.hours && res.data[i].endTime.split(":")[1] > this.minutes) {
                                console.log(res.data[i])
                                this.lessonList= [res.data[i]]
                                this.currentLessonId = res.data[i].lessonId;
                                this.calculateTime(res.data[i].startTime)
                                return;
                            }
                        }
                    }
                    this.$store.commit("setLessonDialogShow", false)
                }
            })
        },
        calculateTime(time) {
            let arr = time.split(":");
            let result = 0;
            this.dialogShow = true;
            if(Number(arr[0]) - this.hours < 0)
                return false;
            result += Number(arr[0]) - this.hours > 0? (arr[0] - this.hours) * 60 * 60 : 0;
            if(Number(arr[1]) - this.minutes >= 0) {
                result += (Number(arr[1]) - this.minutes) * 60;
            } else if(Number(arr[1]) - this.minutes < 0) {
                result -=  (this.minutes - Number(arr[1])) * 60;
            }
            this.countDown = result;
            if(this.countDown > 0) {
                this.disabled = true;
                this.countDownInterval = setInterval(() => {
                    this.countDown = this.countDown - 1;
                    if(this.countDown <= 600) {
                        this.disabled = false;
                    }
                    if(this.countDown < 1) {
                        clearInterval(this.countDownIntervalw)
                    }
                }, 1000)
            }
        },
        //进入课堂弹框显示
        inClassroomDialogVisible(item) {
            if(item.onlineTeaching) {
                if(location.hostname.indexOf('roborobo') > -1) {
                    this.isOSPullClient(item.scheduleId)
                } else {
                    tencentApi.checkScheduleTime(item.scheduleId, res => {
                        if(res.succeed) {
                            this.$router.push(`/classroom?id=${item.scheduleId}`)
                        }
                    })
                }
            } else {
                // this.$refs.codeDialog.visible = true;
                // this.currentLessonId = item.lessonId;
                // this.visible = false;
                communityApi.attendClassByClassCode(item.scheduleId, res => {
                    if(res.succeed) {
                        if(res.data == null || res.data) {
                            this.$router.push({ name: 'sh', query: { lessonId: item.lessonId }});
                        } else {
                            this.$router.push('/sh');
                        }
                    }
                })
            }
            this.$store.commit("setLessonDialogShow", false)
        },
        //判断操作系统，拉起客户端
        isOSPullClient(scheduleId) {
            if(scheduleId) {
                classApi.invokVIPCodeData(scheduleId, res => {
                    if(res.succeed) {
                        if(navigator.userAgent.match(/Windows/i)) {
                            window.CallLiveClient(JSON.stringify({
                                materialId: res.data.materialId,
                                materialUrl: res.data.materialUrl,
                                courseId: res.data.courseId,
                                courseName: res.data.courseName,
                                userId: res.data.userId,
                                userName: res.data.userName,
                                userHeadImg: res.data.userHeadImg,
                                userType: res.data.userType,
                                courseType: res.data.courseType,
                                scratchUrl: res.data.scratchUrl,
                                headId: res.data.headId,
                                liveStreamingId: res.data.liveStreamingId,
                                Members: res.data.members,
                                token: res.data.token,
                                pythonZipUrl: res.data.pythonZipUrl? res.data.pythonZipUrl : "",
                                classType: res.data.classType
                            }));
                        // } else if(navigator.userAgent.match(/Macintosh/i)) {
                        }else{
                            window.webkit.messageHandlers.NativeModel.postMessage({
                                materialId: res.data.materialId,
                                materialUrl: res.data.materialUrl,
                                courseId: res.data.courseId,
                                courseName: res.data.courseName,
                                userId: res.data.userId,
                                userName: res.data.userName,
                                userHeadImg: res.data.userHeadImg,
                                userType: res.data.userType,
                                courseType: res.data.courseType,
                                scratchUrl: res.data.scratchUrl,
                                headId: res.data.headId,
                                liveStreamingId: res.data.liveStreamingId,
                                Members: res.data.members,
                                token: res.data.token,
                                pythonZipUrl: res.data.pythonZipUrl? res.data.pythonZipUrl : "",
                                classType: res.data.classType
                            })
                        }
                    }
                })
            }
        },
        //关闭弹框
        closeDialog() {
            this.dialogShow = false;
            this.$store.commit("setLessonDialogShow", false)
        },
    },
}
</script>
<style lang="scss">
.lessonDialog {
    .el-dialog__body {
        padding: 0px;
        padding-bottom: 0px !important;
    }
    .pptCover {
        width: 100%;
    }
    .flex {
        display: flex;
        flex-direction: row;
        justify-content: center;
        font-size: 18px;
        padding: 5px;
    }
    .flex-end {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        padding: 5px;
    }
    .button {
        font-size: 18px;
    }
    .defaultText {
        display: inline-block;
        width: 100%;
    }
    .lessonName {
        display: inline-block;
        font-size: 16px;
        padding-top: 5px;
    }
}

</style>


// WEBPACK FOOTER //
// src/views/lesson/component/lessonDialog.vue